
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './ChatBot.css'; // You can define your styles here
import M from '../assets/משאית.png';
import B1 from '../assets/12.png';
import B2 from '../assets/13.png';
import Loading from './Loading';
import { ClipLoader } from 'react-spinners';


const styles = {
  spinnerContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    marginTop: '250px'
  },
};

const Chat = ({ setShowHeader }) => {
  const [loading, setLoading] = useState(true);


  const changeBodyBackground = ()=> {
    const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent); // מזהה iOS
  
    document.body.style.position = "relative"; // ב-iOS נשתמש ב-'relative' במקום 'fixed'
    document.body.style.background = "linear-gradient(to bottom, #9e9f5db3, #ffffff)";
    document.body.style.backgroundSize = "cover";
    document.body.style.height = "100vh";
  
    if (!isIOS) {
      document.body.style.backgroundAttachment = "fixed"; // רק באנדרואיד
    } else {
      document.body.style.overflow = "hidden"; // מונע בעיות גלילה
    }
  }

  useEffect(() => {
    changeBodyBackground();
  }, []);

  useEffect(() => {
    // Simulate an async operation, like fetching data
    const timer = setTimeout(() => {
      setLoading(false);
    }, 500); // Adjust the delay as needed

    return () => clearTimeout(timer);
  }, []);


  // useEffect(() => {
  //   // Hide the header when entering this component
  //   setShowHeader(false);

  //   // Restore the header when leaving this component
  //   return () => setShowHeader(true);
  // }, [setShowHeader]);

  const navigate = useNavigate();
  const handleClick = (command) => {
    if (command === 'Command1') {
      navigate('/chat_s');
    }
    if (command === 'Command2') {
      navigate('/chat_m');
    }
    // You can add more logic here based on the command
  };
  if (loading) {
    return <Loading />;
  }
  // #a1a35a
  return (
    <>
      <div style={{ display: loading ? 'fixed' : 'none', ...styles.spinnerContainer }}>
        <ClipLoader size={50} color={"#123abc"} />
      </div>
  
      {/* Add a wrapper div to center and limit the width */}
      <div style={{ maxWidth: '400px', margin: '0 auto', textAlign: 'center' }}>
        {/* Your existing content starts here */}
        {/* <img src={M} className="container" style={{
        // backgroundImage: `url(${M})`,
        // backgroundSize: 'cover',
        // backgroundPosition: 'center',
        marginTop: '-7vh',
        height: '100vh', // Full screen height
        width: '100%',
      }}/> */}
        {/* <div style={{minHeight:'60vh' , minWidth:'100%'}}>  */}
  
        {/* </div> */}
        <div style={{ textAlign: 'center' }}>
          <div>
            <div id='A'>ברוכים הבאים</div>
            <div id='B'>לבוט הלוגיסטי</div>
            <div id='C'>של מדור ציוד דת ולוגיסטיקה</div>
            <div id='D'>כל מה שצריך לדעת - עכשיו בכף ידכם !</div>
            <div id='E'>
              <div>כאן תמצאו מענה מהיר ומדוייק לכל שירותי</div>
              <div className='txt'>המדור , הן למשרתי מפקדת הרבנות במחנה</div>
              <div className='txt'>"שורה"  ,  והן בכלל יחידות צה"ל.</div>
              <div className='txt'>אנו מחויבים לספק שירות ומענה יעיל ומהיר</div>
              <div className='txt'>לכל דרישותיכם בזמן וללא תקלות</div>
            </div>
          </div>
          <div id='F'>
            <div>כאן לשירותכם</div>
            <div style={{ marginTop: '-12px' }}>מדור ציוד דת ולוגיסטיקה</div>
          </div>
          {/* <img src={M} /> */}
          <div style={{ textAlign: 'right' }}>
            <img src={M} style={{ display: 'inline-block', verticalAlign: 'bottom', width: '20vh', marginTop: '-8vh', marginRight: '-4vh' }} alt="Image" />
          </div>
        </div>
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          marginTop: '1.5vh'
        }}>
          <a href="chat_m" style={{ marginTop: '1.5vh' }} >
            <img
              style={{ width: '280px' }}
              src={B1}
              alt="Button Image"
            />
          </a>
  
          <a href="chat_s" style={{ marginTop: '1vh' }}>
            <img
              style={{ width: '280px' }}
              src={B2}
              alt="Button Image"
            />
          </a>
        </div>
      </div> {/* Closing the new wrapper div */}
    </>
  );
  
};



export default Chat;
